// home-mockup-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Gire a roleta e concorra a brindes": "Gira la ruleta y participa por premios",
    "Ilustrações de exemplo; o conteúdo real vem do cadastro da rede.": "Ilustraciones de ejemplo; el contenido real proviene del registro de la red.",
    "Pagamento pendente": "Pago pendiente",
    "Pagar agora": "Pagar ahora",
    "Você tem 2 giros": "Tienes 2 giros",
};

export default catalogo;
